import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { jsx } from 'react/jsx-runtime';

var Tabs = TabsPrimitive.Root;
var TabsList = React.forwardRef(function TabsList2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    TabsPrimitive.List,
    {
      ref,
      className: cn(
        // Never wider than its container: five tabs on the seed page measured
        // 640px in a 492px card and scrolled the WHOLE page sideways, the last
        // tab off-screen (2026-10-01). The strip scrolls itself instead —
        // `justify-start`, since a centred overflow clips its first tab
        // where no scrollbar can reach; a strip that fits shrink-wraps anyway.
        "inline-flex h-9 max-w-full items-center justify-start overflow-x-auto rounded-lg bg-muted p-1 text-muted-foreground",
        className
      ),
      ...props
    }
  );
});
var TabsTrigger = React.forwardRef(function TabsTrigger2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    TabsPrimitive.Trigger,
    {
      ref,
      className: cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm focus-ring",
        className
      ),
      ...props
    }
  );
});
var TabsContent = React.forwardRef(function TabsContent2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    TabsPrimitive.Content,
    {
      ref,
      className: cn("mt-2 ring-offset-background focus-visible:outline-hidden", className),
      ...props
    }
  );
});

export { Tabs, TabsContent, TabsList, TabsTrigger };
//# sourceMappingURL=chunk-Z2NUSCHM.js.map
//# sourceMappingURL=chunk-Z2NUSCHM.js.map